import askGithub from './../lib/askGithub'
import ERROR_CODES from './../lib/errorCodes'

/**
 * Gets information about the current user and their repositories (only returns
 * private repositories).
 * @param {string} authToken
 * @param {number} totalRepositories The total repositories to get
 * @return {object} With props 'user', 'repositories', 'organisations' and
 * 'pageInfo'. Page info is akin to paging through the graphql endpoint
 */
async function getUserAndOrgsAndRepos(authToken, totalRepositories){

  var result = await askGithub(authToken, `query{
    viewer {
      id,
      name,
      avatarUrl,
      organizations(first:100) {
        edges {
          node {
            name
            id
          }
        }
      }
      repositoriesContributedTo(
        first: ${totalRepositories},
        orderBy: {
          field: UPDATED_AT
          direction: DESC
        }
      ) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            name
            id
            updatedAt
            isPrivate
            owner {
              id
            }
          }
        }
      }
    }
  }`)
  if (result['errors'] && result['errors'].length >= 1){
    // Throw the first error
    var error = new Error(result['errors'][0])
    error.code = ERROR_CODES.GITHUB_GRAPH_QL_ERROR
    throw error
  }

  // Grab all the data attached to the user
  var user = result['data']['viewer']
  var repositoriesData = user['repositoriesContributedTo']
  delete user['repositoriesContributedTo']
  // Grab the organisations, this doesn't bother paging threw them, assumes
  // the user will have less than 100
  var organizationsData = user['organizations']
  delete user['repositoriesContributedTo']
  delete user['organizations']


  var organisations = []

  // Add the organizations
  organizationsData['edges'].forEach(edge => {
    var org = edge['node']
    organisations.push(org)
  })

  var repositories = []
  repositoriesData['edges'].forEach(edge => {
    var repository = edge['node']
    if (repository['isPrivate'] != true) return
    repository.ownerId = repository['owner']['id']
    delete repository['owner']
    delete repository['isPrivate']
    repositories.push(repository)
  })


  return {
    user,
    organisations,
    repositories,
    pageInfo: {
      hasNextPage: repositoriesData['pageInfo']['hasNextPage'],
      cursor: repositoriesData['pageInfo']['endCursor'],
    },
  }

}

export default getUserAndOrgsAndRepos



/**
 * This is a continuation of the above but does not return user and organisation
 * data, and pages through the remaining repositories
 * @param {string} authToken
 * @param {string} cursor Grab this from the last query inside the pageInfo object
 * @param {number} total
 * @return {object} Returns keys 'repositories' and 'pageInfo'
 */
export async function getNextRepos(authToken, cursor, total){
  var result = await askGithub(authToken, `query{
    viewer {
      repositoriesContributedTo(
        first: ${total},
        orderBy: {
          field: UPDATED_AT
          direction: DESC
        }
        after: "${cursor}"
      ) {
        pageInfo {
          hasNextPage,
          endCursor
        }
        edges {
          node {
            name
            id
            updatedAt
            isPrivate
            owner {
              id
              login
            }
          }
        }
      }
    }
  }`)

  var repositoriesData = result['data']['viewer']['repositoriesContributedTo']
  var repositories = []
  repositoriesData['edges'].forEach(edge => {
    var repository = edge['node']
    if (repository['isPrivate'] != true) return
    repository.ownerId = repository['owner']['id']
    delete repository['owner']
    delete repository['isPrivate']
    repositories.push(repository)
  })

  return {
    repositories,
    pageInfo: {
      hasNextPage: repositoriesData['pageInfo']['hasNextPage'],
      cursor: repositoriesData['pageInfo']['endCursor'],
    },
  }
}


// WEBPACK FOOTER //
// ./src/data/getUserAndOrgsAndRepos.js